
import "swiper/css/swiper.css";
import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { QnaVO } from "./vo/qna.vo";
import { ProductVO } from "./vo/product.vo";

@Component
export default class Qna extends Vue {
  @Prop() productCd!: string;

  //data
  product: ProductVO = {} as ProductVO;

  //computed
  get content() {
    if(!this.product.productQnas) {
      return [];
    }
    this.product.productQnas.forEach((v) => {
      v.qcontents && (v.qcontents = v.qcontents.replace(/\n/g, "<br>"));
    });
    return this.product.productQnas;
  }

  btnMore(index: number) {
    this.product.productQnas.forEach((item: QnaVO, i: number) => {
      if(index == i) {
        item.isExpand = !item.isExpand;
      } else {
        item.isExpand = false;
      }
      this.$set(this.product.productQnas, i, item);
    });
  }

  // 삭제
  deleteQna(item: QnaVO) {
    // 삭제하시겠습니까?
    if(confirm(this.$t('common.c0004').toString()) == false) {
      return;
    }

    axios.delete(`mypage/profile/inquiry-history`, {params: {seq: item.seq}}).then(r=>{
      this.search();
      // 삭제되었습니다.
      alert(this.$t('mypage.a0013'));
    })
  }

  search() {
    // 문의내역
    axios.get(`/product/${this.productCd}/qna`).then((r) => {
      this.product = r.data;
    });
  }

  //initialized events
  created(): void {
    this.search(); 
  }
}
